import React, { Suspense, useState } from "react";
import PropTypes from "prop-types";
import styleModule from "./TopBar.module.sass";
import { ReactComponent as ReactIconUser } from "../../../assets/images/user.svg";
import { ReactComponent as ReactIconWorkstation } from "../../../assets/images/workstation.svg";
import { ReactComponent as ReactIconLogout } from "../../../assets/images/exit.svg";
import { ReactComponent as ReactIconHelp } from "../../../assets/images/question.svg";
import { ReactComponent as ReactIconArrow } from "../../../assets/images/chevron-right.svg";

import { useDispatch, useSelector } from "react-redux";
import {
  validationValue,
  shortName,
  showSchedule
} from "../../../utils/validations";
import useClock from "../../../hooks/useClock";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { logout } from "../../../redux/session/sessionSlice";
import {
  handleChangePart,
  stopWorkingWorkstation
} from "../../../redux/dashboard/dashboardSlice";
import { useMatch, useNavigate } from "react-router-dom";
import handlePathsByTypeWorkstations from "../SideBar/helpers/handlePathsByTypeWorkstations";
import handleShowLogoById from "./helpers/handleShowLogoById";
import LanguageSwitcher from "../../LanguageSwitcher/LanguageSwitcher";
import { supportedLngs } from "../../../utils/ConstCapture";

const TopBar = props => {
  const { user, company, workstation, data } = useSelector(state => ({
    user: state.userData.user,
    company: state.userData.company,

    workstation: state.dashboard.workstationSelected,
    // workstationData: state.dashboard.workstation
    data: state.dashboard.data
  }));
  const [modalLanguage, setModalLanguages] = useState(null);
  const dashboardMatch = useMatch(
    `/${handlePathsByTypeWorkstations(workstation, "dashboard")}`
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const path = window.location.pathname.split("/");
  const pathLanguage = supportedLngs.includes(path[1]) ? path[1] : "?";

  const { i18n } = useTranslation();
  const date = useClock();
  const { t } = useTranslation("general");

  const handleLogout = async () => {
    await dispatch(stopWorkingWorkstation());
    await dispatch(logout());
  };

  const handleLangaugeOptions = () => {
    setModalLanguages(
      <LanguageSwitcher unmount={() => setModalLanguages(null)} />
    );
  };

  return (
    <header className={styleModule.topBar}>
      <section id="logo-header" className={styleModule.logo}>
        {handleShowLogoById(company?.id)}
      </section>
      <section className={styleModule.date}>
        {moment(date).locale(i18n.language).format("DD/MM/YYYY")}
      </section>
      <section className={styleModule.hour}>
        {showSchedule(
          data?.schedule,
          moment(date).local(i18n.language).format("hh:mm a")
        )}
      </section>

      <section className={styleModule.notSection}>
        <button
          className={` ${styleModule.workstationSelected} ${
            workstation && workstation.id && !dashboardMatch
              ? styleModule.btnHeader
              : styleModule.notHasWorkstationSelected
          } ${styleModule.section} ${
            dashboardMatch && styleModule.locateDashboard
          }`}
          onClick={() => {
            if (workstation && workstation.id && !dashboardMatch) {
              dispatch(handleChangePart(false));
              navigate(
                `${path[1]}/${handlePathsByTypeWorkstations(
                  workstation,
                  "dashboard"
                )}`
              );
            }
          }}
        >
          <ReactIconWorkstation height="25px" width="25px" strokeWidth="2px" />
          {workstation ? (
            `${workstation.alias ? workstation.alias : workstation.name}`
          ) : (
            <Suspense fallback={"Cargando..."}>
              {t("noWorkstationSelected")}
            </Suspense>
          )}
        </button>
      </section>

      <section className={styleModule.user}>
        <ReactIconUser height="25px" width="25px" strokeWidth="2px" />
        <span className={styleModule.name}>
          {validationValue(shortName(user?.name), "Desconocido")}
        </span>
      </section>
      <section className={styleModule.notSection}>
        <a
          className={`${styleModule.section} ${styleModule.btnHeader}`}
          target="_blank"
          href="https://docs.monitorapp.io/"
        >
          <ReactIconHelp />
        </a>
      </section>
      <section className={styleModule.notSection}>
        <button
          className={`${styleModule.section} ${styleModule.btnHeader} ${styleModule.languages}`}
          onClick={handleLangaugeOptions}
        >
          {modalLanguage}
          {pathLanguage.toUpperCase()}
          <ReactIconArrow className={styleModule.arrow} />
        </button>
      </section>

      <section className={styleModule.notSection}>
        <button
          className={`${styleModule.section} ${styleModule.btnHeader}`}
          onClick={handleLogout}
        >
          <label className={styleModule.contentBtnLogout}>
            <ReactIconLogout height="25px" width="25px" strokeWidth="2px" />
            <Suspense fallback={"Cargando..."}>{t("exitSystem")}</Suspense>
          </label>
        </button>
      </section>
    </header>
  );
};

TopBar.propTypes = {};

export default TopBar;
